import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context';

interface Props {
    to: string;
}

export default function BackButton({ to: location }: Props) {
    const navigate = useNavigate();
    const { langResources } = useContext(AppContext);

    return (
        <Button variant='light' onClick={(_) => navigate(location)}>
            <i className='ri-arrow-left-line me-1'></i>
            {langResources['back.button']}
        </Button>
    );
}
